import { render } from "./ThankYouModal.vue?vue&type=template&id=b180560e&ts=true"
import script from "./ThankYouModal.vue?vue&type=script&lang=ts"
export * from "./ThankYouModal.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build_d3089a66/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__